/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanySearchInfoRequest = {
  properties: {
    cnpj: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
